exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pseudo-console_pseudo-console-wrapper_31sMV {\r\n    font-family: monospace;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: black;\r\n    color: white;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"pseudo-console-wrapper": "pseudo-console_pseudo-console-wrapper_31sMV",
	"pseudoConsoleWrapper": "pseudo-console_pseudo-console-wrapper_31sMV"
};